// @flow

export function setCookie(field: string, value: string, conference: string) {
  document.cookie = field + "=" + value + "; path=/" + conference;
}

export function getCookie(cname: string): string {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteCookie(field: string, conference: string) {
  document.cookie = field + "=; path=/" + conference + "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}


// WEBPACK FOOTER //
// ./src/global/functions/cookies.js